ACC.vistexCoupon = {
  statusObj: {
    triggerValue: 'vistexVoucher.apply',
    componentName: 'vistexVoucher',
    description: 'Cart page - Vistex Voucher Apply',
    value: '',
    status: ''
  },
  validateVistexCoupon: function(val) {
    if (val.toString() !== '') {
      return true;
    }

    return false;
  },

  applyVistexVoucherCode: function() {
    var $vistexCouponInpEle = $('#ph-vistex-coupon-inp'),
        vistexCouponValidationflag = ACC.vistexCoupon.validateVistexCoupon($vistexCouponInpEle.val()),
        emptyErrMsg = '',
        $phVistexCouponBtn = $('#ph-vistex-coupon-btn');

    if (vistexCouponValidationflag === false) {
      emptyErrMsg = $vistexCouponInpEle.closest('.ph-vistex-coupon-code.ph-inputData').attr('data-emptycontent');
      $vistexCouponInpEle.closest('.ph-signup__error').addClass('form_field_error ph-form_field_error');
      $vistexCouponInpEle.closest('.ph-signup__error').find('.ph-validation-err-msg').text(emptyErrMsg);
    } else {
      $vistexCouponInpEle.closest('.ph-signup__error').removeClass('form_field_error ph-form_field_error');
      $vistexCouponInpEle.closest('.ph-signup__error').find('.ph-validation-err-msg').text('');
      $('#checkouthref').prop('disabled', true).addClass('ph-disable-button');
      $phVistexCouponBtn.addClass('ph-disable-button').find('.ph-interstitial-loader').removeClass('hidden');
      $.ajax({
        url: ACC.config.encodedContextPath + '/cart/applyVoucherCode',
        data: {
          voucherCode: encodeURIComponent($vistexCouponInpEle.val())
        },
        type: 'POST',
        Datatype: 'json',
        success: function(res) {
          if (res === 'true') {
            window.location.reload();
          } else {
            $('#checkouthref').prop('disabled', false).removeClass('ph-disable-button');
            $phVistexCouponBtn.removeClass('ph-disable-button').find('.ph-interstitial-loader').addClass('hidden');
            emptyErrMsg = $vistexCouponInpEle.closest('.ph-vistex-coupon-code.ph-inputData').attr('data-invalidcode');
            $vistexCouponInpEle.closest('.ph-signup__error').addClass('form_field_error ph-form_field_error');
            $vistexCouponInpEle.closest('.ph-signup__error').find('.ph-validation-err-msg').text(emptyErrMsg);
            ACC.vistexCoupon.statusObj.value = $vistexCouponInpEle.val();
            ACC.vistexCoupon.statusObj.status = 'fail';
            ACC.googleanalytics.gaForSuccessFail(ACC.vistexCoupon.statusObj);
          }
        }
      });
    }
  }
};

$(document).ready(function() {
  $(document).on('click', '#ph-vistex-coupon-btn', function() {
    ACC.vistexCoupon.applyVistexVoucherCode();
  });

  $(document).on('keypress', '#ph-vistex-coupon-inp', function(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      ACC.vistexCoupon.applyVistexVoucherCode();
    }
  });

  $(document).on('click', '#ph-vistex-coupon-remove', function() {
    $('#checkouthref').prop('disabled', true).addClass('ph-disable-button');
    $.ajax({
      url: ACC.config.encodedContextPath + '/cart/removeVoucherCode',
      type: 'GET',
      success: function() {
        window.location.reload();
      }
    });
  });

  // eslint-disable-next-line require-jsdoc
  function createVistexEventObj(url, desc, trigger, compname) {
    return {
      url: url,
      description: desc,
      trigger: trigger,
      compname: compname
    };
  }

  $(document).on('click', '.ph-vistex-coupon-apply-btn', function() {
    var urlLink = window.location.protocol + '//' + window.location.host + ACC.config.encodedContextPath + '/cart',
        trigger = 'vistexVoucher.clickApply',
        compname = '.ph-vistex-coupon-apply-btn',
        desc = 'Apply Vistex Voucher',
        vistexEventObj = '';

    vistexEventObj = createVistexEventObj(urlLink, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(vistexEventObj);
  });

  $(document).on('click', '.ph-vistex-coupon-remove-lnk', function() {
    var urlLink = window.location.protocol + '//' + window.location.host + ACC.config.encodedContextPath + '/cart',
        trigger = 'vistexVoucher.clickRemove',
        compname = '.ph-vistex-coupon-remove-lnk',
        desc = 'Remove Vistex Voucher',
        vistexEventObj = '';

    vistexEventObj = createVistexEventObj(urlLink, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(vistexEventObj);
  });

  if ($('.ph-vistex-coupon-remove-lnk').length > 0) {
    ACC.vistexCoupon.statusObj.status = 'success';
    ACC.googleanalytics.gaForSuccessFail(ACC.vistexCoupon.statusObj);
  }

  $(document).on('click', '.ph-dealButton,.ph-dealAnchorLink', function() {
    ACC.googleanalytics.gaEventsForLinks({
      url: window.location.protocol + '//' + window.location.host + ACC.config.encodedContextPath + '/c/DEALS_GR',
      description: 'Deals Button Click',
      trigger: 'dealbutton.click',
      value: $(this).attr('data-dealnumber'),
      compname: 'dealButton'
    });
  });
});

